const fornecedor = (DataBase, Datatype) => {
	const Fornecedor = DataBase.new(
		{
			id_municipio: Datatype.NUMBER,
			id_estado: Datatype.NUMBER,
			nome: Datatype.STRING,
			razao_social: Datatype.STRING,
			cnpj: Datatype.STRING,
			ie: Datatype.STRING,
			cep: Datatype.STRING,
			endereco: Datatype.STRING,
			fone: Datatype.STRING,
			email: Datatype.STRING,
		},
		{
			tracked: true,
			dateLogs: true,
			softDelete: true,
			collection: "fornecedor",
			model: "Fornecedor",
		}
	);

	return Fornecedor;
};

export default fornecedor;
